import { Input, Directive } from '@angular/core';
import {ControlValueAccessor} from '@angular/forms';

@Directive()
export abstract class DropdownFormControl<T> implements ControlValueAccessor {
    public allValues: T[];
    @Input()
    public errorMessage: string;
    @Input()
    public formControlName: string;
    private _selectedValue: T;
    private onChangeListener: (_: any) => {};

    protected constructor() {
        this.onChangeListener = () => {
            return {};
        };
    }

    get selectedValue(): T {
        return this._selectedValue;
    }

    set selectedValue(value: T) {
        this._selectedValue = value;
        this.onChangeListener(value);
    }

    registerOnTouched(fn: any): void {
    }

    setDisabledState(isDisabled: boolean): void {
    }

    registerOnChange(fn: any): void {
        this.onChangeListener = fn;
    }

    writeValue(value: T): void {
        this._selectedValue = value;
    }
}